import { jsxs as _jsxs } from "react/jsx-runtime";
import { SOFTWARE_CLIENT_VERSION } from "../../config/config.dev";
var RenderVersionInfo = function () {
    return (_jsxs("div", { children: [_jsxs("div", { children: ["SOFTWARE_CLIENT_VERSION: ", SOFTWARE_CLIENT_VERSION] }), _jsxs("div", { children: ["NODE_ENV:", process.env.NODE_ENV] }), _jsxs("div", { children: ["ENVIRONMENT: ", process.env.ENVIRONMENT] })] }));
};
export default RenderVersionInfo;
